/* tslint:disable */

/**
 */
export class PointValue {
    name?: number;
    value?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/point-value.ts